import React from 'react'
import { connect } from 'react-redux'
import constants from '../../constants'
import { put } from '../../Services/http'
import { isNullOrWhiteSpace } from '../../Services/strings'
import { translate } from '../../Services/translation'
import MobileNavigation from '../../Components/Navigation/Mobile'
import { setCookie } from '../../Services/cookieService'

const MobileNavigationContainer = ({ navigation, ...props }) => {
    const extra = {
        footerItems: footerItems(navigation),
        countryNav: countryNav(),
    }
    return <MobileNavigation {...props} {...extra} />
}

const mapStateToProps = (state) => {
    return {
        links: state.navigation.contentLinks,
        navigation: state.navigation,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MobileNavigationContainer)

function footerItems({
    isLoggedIn,
    myPage,
    loggedInUserFullName,
    loginPage,
    createAccountPage,
}) {
    return (
        isLoggedIn
            ? [{ page: myPage, text: loggedInUserFullName }]
            : [
                  { page: loginPage, text: loggedInUserFullName },
                  { page: createAccountPage },
              ]
    )
        .map(({ page, text }) => ({
            href: page?.href,
            text: text ?? page?.text,
        }))
        .filter((x) => !isNullOrWhiteSpace(x.href))
}

function countryNav() {
    const { countryLanguagePairs } = constants || {}
    if (!countryLanguagePairs || countryLanguagePairs.length === 0) {
        return null
    }

    const currentCountryName = window.__litium.currentCountryName
    const currentCountry = countryLanguagePairs.find(
        (country) =>
            country.attributes.alpha2 === window.__litium.currentCountryAlpha2
    )

    const attributes = currentCountry?.attributes

    return {
        img: attributes?.imgSrc && {
            src: attributes.imgSrc,
            alt: attributes.alpha2,
        },
        name: `${translate(
            'languagelinks.countryselect.title'
        )} ${currentCountryName}`,
        attributes: {
            alpha2: attributes?.alpha2,
        },
        links: constants.countryLanguagePairs.map(
            ({ href, text, attributes }) => ({
                img: attributes?.imgSrc && {
                    src: attributes.imgSrc,
                    alt: attributes.alpha2,
                },
                name: text,
                url: href,
                onClick: async (event) => {
                    setCookie(
                        window.__litium.geoLocationData.cookieName,
                        attributes.alpha2
                    )
                    event.preventDefault()
                    await put(`/api/navigation/setCountry/${attributes.alpha2}`)
                    window.location = href
                },
            })
        ),
        fullRule: true,
    }
}
